import React from 'react'
// import { graphql, useStaticQuery } from 'gatsby'
import Image from 'gatsby-image'
// import { findDOMNode } from 'react-dom'
import styled, { css } from 'styled-components'
import ReactPlayer from 'react-player'
// import { FaPlay, FaPause, FaExpand } from 'react-icons/fa'
// import screenfull from 'screenfull'
// import { CSSTransition } from 'react-transition-group'

import BasicResponsiveVideo from './BasicResponsiveVideo'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
`

const Player = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

const CustomPlayer = styled(Player)`
  /* iframe {
    pointer-events: none;
  } */
`

const BottomArea = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
`

const PlayerControls = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    padding: ${theme.spacers.small};
    color: ${theme.colors.main.secondary};
    background-color: ${theme.colors.neutral.black};

    &.player {
      &-enter {
        opacity: 1;
      }

      &-enter-active {
        opacity: 1;
        transition: opacity 1s;
      }

      &-exit {
        opacity: 1;
      }

      &-exit-active {
        opacity: 1;
        transition: opacity 1s;
      }
    }
  `}
`

const SeekingBar = styled.input.attrs({
  type: 'range',
  min: 0,
  max: 1,
  step: 'any',
})`
  ${({ theme }) => css`
    appearance: none;
    flex: 1;
    margin: 0 ${({ theme }) => theme.spacers.small};
    height: 3px;
    background-color: ${theme.colors.main.secondary};

    &::-webkit-slider-thumb {
      appearance: none;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-color: ${theme.colors.accent.secondaryLighten30};
      cursor: pointer;
    }

    &::-moz-range-thumb {
      appearance: none;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-color: ${theme.colors.accent.secondaryLighten30};
      cursor: pointer;
    }

    &:focus {
      outline: none;
    }
  `}
`

const ControlButton = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
`

const DescArea = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 130px;
    background-color: ${theme.colors.neutral.gray2000};
    padding: ${theme.spacers.normal};

    &.desc-area {
      &-enter {
        opacity: 1;
      }

      &-enter-active {
        opacity: 1;
        transition: opacity 1s;
      }

      &-exit {
        opacity: 1;
      }

      &-exit-active {
        opacity: 1;
        transition: opacity 1s;
      }
    }
  `}
`

const HeaderArea = styled.header`
  ${({ theme }) => css`
    display: flex;
    position: absolute;
    align-items: center;
    top: 0;
    width: 100%;
    height: 60px;
    padding: ${theme.spacers.normal};
    background-color: ${theme.colors.main.primary};

    &.header-area {
      &-enter {
        opacity: 1;
      }

      &-enter-active {
        opacity: 1;
        transition: opacity 6s;
      }

      &-exit {
        opacity: 1;
      }

      &-exit-active {
        opacity: 1;
        transition: opacity 6s;
      }
    }
  `}
`

const HeaderAreaTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.neutral.white};
    font-family: ${theme.fontFamily.heading};
  `}
`

const HeaderAreaImage = styled(Image)`
  ${({ theme }) => css`
    margin-right: ${theme.spacers.normal};
    background-color: ${theme.colors.neutral.white};
    border-radius: 50%;
  `}
`

const DescAreaTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.neutral.white};
    font-family: ${theme.fontFamily.heading};
  `}
`

const DescAreaBody = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.neutral.gray600};
    margin: ${theme.spacers.normal} 0;
    font-size: ${theme.fontSizes.small};
  `}
`

const SpeedButton = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.neutral.white};
    font-family: ${theme.fontFamily.heading};
    margin-right: ${theme.spacers.small};
  `}
`

const SpeedMenu = styled.div`
  ${({ theme }) => css`
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    bottom: 60px;
    border-radius: ${theme.round.normal};
    overflow: hidden;

    &.speed {
      &-enter {
        opacity: 0;
        transform: translate(-50%, 30px);
      }

      &-enter-active {
        opacity: 0.5;
        transform: translate(-50%, 0);
        transition: opacity 250ms, transform 250ms;
      }

      &-exit {
        opacity: 0.5;
        transform: translate(-50%, 0);
      }

      &-exit-active {
        opacity: 0;
        transform: translate(-50%, 30px);
        transition: opacity 250ms, transform 250ms;
      }
    }
  `}
`

const SpeedMenuItem = styled.div`
  ${({ theme, active }) => css`
    background-color: ${theme.colors.neutral.black};
    color: ${theme.colors.neutral.white};
    padding: 0 ${theme.spacers.normal};
    transition: 0.25s background-color;

    ${active &&
    css`
      background-color: ${theme.colors.main.secondary};
    `}

    &:hover {
      background-color: ${theme.colors.main.primary};
    }
  `}
`

const Timer = styled.div`
  ${({ theme, timer }) => css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: ${theme.colors.main.secondary};

    &::after {
      position: absolute;
      content: '${timer}';
      font-family: ${theme.fontFamily.heading};
      font-size: ${theme.fontSizes.large};
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: ${theme.colors.neutral.white};
    }
  `}
`

const config = {
  youtube: {
    playerVars: { modestbranding: 1 },
  },
  file: {
    hlsOptions: {
      maxBufferSize: 0.5,
      maxBufferLength: 5
    }
  }
}

// function CustomResponsiveVideo({ className, ...props }) {
//   const playerWrapper = useRef(null)
//   const player = useRef(null)
//   const seekingBar = useRef(null)
//   const [playing, setPlaying] = useState(props.playing || false)
//   const [played, setPlayed] = useState(0)
//   const [speed, setSpeed] = useState(1)
//   const [hoveredPlayer, sethoveredPlayer] = useState(false)
//   const [isSpeedMenuShown, setIsSpeedMenuShow] = useState(false)
//   const { logo } = useStaticQuery(graphql`
//     query {
//       logo: imageSharp(original: { src: { regex: "/logo/" } }) {
//         fixed(width: 40, height: 40) {
//           ...GatsbyImageSharpFixed_withWebp
//         }
//       }
//     }
//   `)
//   const [playTimer, setPlayTimer] = useState(false)
//   const [timer, setTimer] = useState(5)
//   const timerId = useRef(null)

//   const handleEnded = useCallback(() => {
//     if (!props.onEnded) return

//     setPlayTimer(true)
//   }, [setPlayTimer, props.onEnded])

//   const togglePlaying = useCallback(() => setPlaying(!playing), [
//     playing,
//     setPlaying,
//   ])

//   const toggleFullscreen = useCallback(
//     (event) => {
//       event.stopPropagation()

//       if (screenfull.isFullscreen) {
//         screenfull.exit()
//       } else {
//         screenfull.request(findDOMNode(playerWrapper.current))
//       }
//     },
//     [playerWrapper]
//   )

//   const recordPlayed = useCallback(({ played }) => setPlayed(played), [])

//   const seekChange = useCallback(
//     (event) => {
//       setPlayed(parseFloat(event.target.value))
//       setPlaying(true)
//     },
//     [setPlayed]
//   )

//   const seekMouseUp = useCallback(
//     (event) => player.current?.seekTo(parseFloat(event.target.value)),
//     [player]
//   )

//   const toggleSpeedMenu = useCallback(
//     (event) => {
//       event.stopPropagation()

//       setIsSpeedMenuShow(!isSpeedMenuShown)
//     },
//     [isSpeedMenuShown, setIsSpeedMenuShow]
//   )

//   const changeSpeed = useCallback(
//     (speed) => (event) => {
//       event.stopPropagation()

//       setSpeed(parseFloat(speed))
//     },
//     [setSpeed]
//   )

//   const onOverWrapper = useCallback(() => sethoveredPlayer(true), [
//     sethoveredPlayer,
//   ])

//   const onOutWrapper = useCallback(() => sethoveredPlayer(false), [
//     sethoveredPlayer,
//   ])

//   useEffect(() => {
//     if (!playTimer) return
//     if (timer === 0) return props.onEnded()

//     timerId.current = setInterval(() => setTimer(timer - 1), 1000)

//     return () => clearInterval(timerId.current)
//   }, [playTimer, setTimer, timer])

//   return (
//     <Wrapper
//       ref={playerWrapper}
//       className={className}
//       onClick={togglePlaying}
//       onMouseOver={onOverWrapper}
//       onMouseOut={onOutWrapper}
//     >
//       <CustomPlayer
//         ref={player}
//         width="100%"
//         height="100%"
//         {...props}
//         playing={playing}
//         controls={false}
//         config={config}
//         playbackRate={speed}
//         onProgress={recordPlayed}
//         onEnded={handleEnded}
//       ></CustomPlayer>
//       {playTimer && <Timer timer={timer}></Timer>}
//       <CSSTransition
//         in={!playing}
//         timeout={6000}
//         classNames="header-area"
//         unmountOnExit
//       >
//         <HeaderArea>
//           <HeaderAreaImage
//             fixed={logo.fixed}
//             alt="Babel Coder"
//           ></HeaderAreaImage>
//           <HeaderAreaTitle>{props.title || 'ไม่พบชื่อวิดีโอ'}</HeaderAreaTitle>
//         </HeaderArea>
//       </CSSTransition>
//       <BottomArea>
//         {/* <CSSTransition
//           in={!playing}
//           timeout={1000}
//           classNames="desc-area"
//           unmountOnExit
//         >
//           <DescArea>
//             <DescAreaTitle>คำอธิบาย</DescAreaTitle>
//             <DescAreaBody>
//               {props.desc || 'ไม่พบคำอธิบายประกอบวิดีโอ'}
//             </DescAreaBody>
//           </DescArea>
//         </CSSTransition> */}
//         <CSSTransition
//           in={!playing || hoveredPlayer}
//           timeout={4000}
//           classNames="player"
//           unmountOnExit
//         >
//           <PlayerControls onClick={(event) => event.stopPropagation()}>
//             <ControlButton onClick={togglePlaying}>
//               {playing ? <FaPause></FaPause> : <FaPlay></FaPlay>}
//             </ControlButton>
//             <SeekingBar
//               ref={seekingBar}
//               value={played}
//               onChange={seekChange}
//               onMouseUp={seekMouseUp}
//             ></SeekingBar>
//             <ControlButton onClick={toggleSpeedMenu}>
//               <SpeedButton>{speed}x</SpeedButton>
//               <CSSTransition
//                 in={isSpeedMenuShown}
//                 timeout={250}
//                 classNames="speed"
//                 unmountOnExit
//               >
//                 <SpeedMenu>
//                   {[0.5, 0.75, 1, 1.5, 1.75, 2].map((loopSpeed) => (
//                     <SpeedMenuItem
//                       key={loopSpeed}
//                       active={speed === loopSpeed}
//                       onClick={changeSpeed(loopSpeed)}
//                     >
//                       {loopSpeed}x
//                     </SpeedMenuItem>
//                   ))}
//                 </SpeedMenu>
//               </CSSTransition>
//             </ControlButton>
//             <ControlButton onClick={toggleFullscreen}>
//               <FaExpand></FaExpand>
//             </ControlButton>
//           </PlayerControls>
//         </CSSTransition>
//       </BottomArea>
//     </Wrapper>
//   )
// }

// function ResponsiveVideo({ custom = false, ...props }) {
//   return custom ? (
//     <CustomResponsiveVideo {...props}></CustomResponsiveVideo>
//   ) : (
//     <BasicResponsiveVideo {...props}></BasicResponsiveVideo>
//   )
// }

function isAppleBrowser() {
  return (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    // || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  )
}

function ResponsiveVideo({ custom = false, ...props }) {
  if (
    props.url.startsWith('https://www.youtube-nocookie.com/embed') ||
    props.url.startsWith('https://www.youtube.com') ||
    props.url.startsWith('https://youtu.be')
  ) {
    return <BasicResponsiveVideo {...props}></BasicResponsiveVideo>
  }

  const url = isAppleBrowser() ? `${props.url}.m3u8` : `${props.url}.mpd`


  return <BasicResponsiveVideo {...props} url={url}></BasicResponsiveVideo>
}

export default ResponsiveVideo
